import ContactLink from "@/components/ContactLink";
import { Link } from "@inertiajs/react";
import Screenshot from "@/components/help/Screenshot";
import ActivationCard from "@/components/parents/ActivationCard";

export default function MultipleChildren() {
  return (
    <>
      <p>
        Your account can hold as many children as you want — siblings at the same school, kids at different schools, children you co-parent across households. After the first one, adding more takes about 20 seconds.
      </p>

      <h2>Adding another child</h2>
      <p>
        At the bottom of your sidebar, click <strong>Add another child</strong>. Type their activation code (or scan their QR if they came home with their own take-home sheet). They show up in your sidebar right away — no email link this time, since you're already signed in.
      </p>
      <Screenshot caption="Adding a child">
        <div className="max-w-md mx-auto">
          <ActivationCard claim_code="EAGLE-RIVER-1936" email="parent@example.com" variant="embedded" />
        </div>
      </Screenshot>

      <h2>Both parents on the same child</h2>
      <p>
        Co-parents can both follow the same child. The other parent uses the same activation code on their own account, and they'll see everything you do. The same sheet works for grandparents too — pass it on, they'll get their own view.
      </p>

      <h2>Children at different schools</h2>
      <p>
        Same flow. Sign up for each child with their own take-home sheet. They'll all show up in your sidebar even if they go to different schools.
      </p>

      <p>
        Each child has their own personal goal, their own reading logs, their own donation page. Click any name in the sidebar to switch to them.
      </p>

      <p>
        If you ever need to remove a child from your account (a shared device gone wrong, that sort of thing), email <ContactLink>hello@pagepledge.com</ContactLink> and we'll sort it out.
      </p>

      <h2>What's next</h2>
      <ul>
        <li><Link href="/help/articles/parent-dashboard">Your dashboard</Link>.</li>
        <li><Link href="/help/articles/sharing-with-family">Sharing with family</Link>.</li>
      </ul>
    </>
  );
}
